"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioButtonCustom = void 0;
var radioButtonCustom = function () {
    console.log('radioButtonCustom');
    var gchoiceLabels = document.querySelectorAll('.gchoice label');
    var gfieldRadioInputs = document.querySelectorAll('.gfield_radio .gchoice .gfield-choice-input');
    var defaultBgColor = '#f0f0f0';
    var selectedBgColor = 'rgba(48, 81, 255, 0.15)';
    for (var _i = 0, _a = Array.from(gchoiceLabels); _i < _a.length; _i++) {
        var label = _a[_i];
        label.addEventListener('click', function () {
            var inputId = this.getAttribute('for');
            if (inputId !== null) {
                var inputElement = document.getElementById(inputId);
                if (inputElement !== null) {
                    inputElement.checked = true;
                }
            }
        });
    }
    for (var _b = 0, _c = Array.from(gfieldRadioInputs); _b < _c.length; _b++) {
        var input = _c[_b];
        input.addEventListener('click', function () {
            // 全ての.gchoice要素の背景色をリセット
            for (var _i = 0, _a = Array.from(document.querySelectorAll('.gchoice')); _i < _a.length; _i++) {
                var choice = _a[_i];
                ;
                choice.style.backgroundColor = defaultBgColor;
            }
            // 選択されたラジオボタンの親要素の背景色を変更
            if (this.checked) {
                ;
                this.parentElement.style.backgroundColor =
                    selectedBgColor;
            }
        });
    }
};
exports.radioButtonCustom = radioButtonCustom;
